export enum DocumentAccessContentType {
  NotLoggedIn = 0,
  MissingPackageOrExtension = 1,
  ExpiredTestPeriod = 2,
  NotFetched = 3,
}
